import { Component, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { CHART_INTERACTIVE_MODE, CHART_PRESENTATION_MODE } from 'ChartApp/ts/features/charts-shared/constants';

@Component({ standalone: false, selector: 'ycn-chart-type-toggle', templateUrl: './chart-type-toggle.template.html' })
export class ChartTypeToggleComponent implements OnDestroy {
    INTERACTIVE_MODE = CHART_INTERACTIVE_MODE;

    PRESENTATION_MODE = CHART_PRESENTATION_MODE;

    chartType: string = CHART_INTERACTIVE_MODE;

    storeSubscription: Subscription;

    @Input() setChartTypeAction: any;

    constructor(public store: Store<{ reducers: Record<string, any> & { chartType: any } }>) {
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }

    ngOnDestroy(): void {
        this.storeSubscription.unsubscribe();
    }

    mapStateToComponent = (state: Record<string, any>): void => {
        this.chartType = state[state.appStateSliceKey].chartType;
    };

    toggleChartType(event: Event): void {
        event.preventDefault();
        const newChartType =
            this.chartType === CHART_INTERACTIVE_MODE ? CHART_PRESENTATION_MODE : CHART_INTERACTIVE_MODE;
        this.store.dispatch(this.setChartTypeAction({ chartType: newChartType }));
    }
}
